import React, { useContext, useEffect } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import RouteContext from 'src/routes/context';
import throttle from 'lodash/throttle';
import SecondarySearchField from '@prisjakt/ui-secondary-search-field';
import * as S from './styles';

const SEARCH_THROTTLE = 750;

const throttledSearch = throttle(
  (id: string, query: string, dispatch: (action: any) => void) =>
    dispatch({
      type: 'AGGREGATION_SEARCH',
      id,
      query: query.length > 1 ? query : '', // one letter searches return empty
    }),
  SEARCH_THROTTLE
);

type Props = {
  autoFocusSearch?: boolean;
  id: string;
  searchQuery?: string;
  setSearchQuery: (query?: string) => void;
  title: string;
};

export const ListSearch = (props: Props) => {
  const { autoFocusSearch, id, searchQuery, setSearchQuery, title } = props;
  const { t } = useContext(AppContext);

  const { dispatch } = useContext(RouteContext);

  useEffect(() => {
    if (searchQuery !== undefined) {
      throttledSearch(id, searchQuery, dispatch);
    }
  }, [searchQuery, id, dispatch]);

  return (
    <S.SearchInputWrapper>
      <SecondarySearchField
        value={searchQuery}
        onChange={setSearchQuery}
        clearText={t('common', 'button.clear')}
        placeholder={t('filter', 'filter.search-aggregation', {
          filter: title.toLowerCase(),
        })}
        autoFocus={autoFocusSearch}
      />
    </S.SearchInputWrapper>
  );
};
